<template>
  <v-dialog v-model="modal" max-width="600px" scrollable>
    <v-card>
      <v-card-title>Reject Form</v-card-title>
      <v-card-text>
        <div>
          <v-select
            v-if="
              selectedForm.attributes &&
                selectedForm.attributes.rejecting_reasons.length
            "
            :items="selectedForm.attributes.rejecting_reasons || []"
            label="Reason for rejecting"
            v-model="selectedReason"
            outlined
          />
          <v-textarea
            label="Reason"
            rows="3"
            v-model="selectedReason"
          ></v-textarea>
        </div>
      </v-card-text>

      <div
        v-if="
          isSignatureRequired &&
            selectedSubmission.submission_status === 'pending'
        "
        class="mx-4"
      >
        <option-signature
          :formId="selectedSubmission.id"
          @signature-generated="handleSignature"
          @signature-cleared="clearSignature"
          :question="signatureQuestion || {}"
          :label="signatureQuestion.title || ''"
        />
      </div>

      <v-card-actions>
        <v-btn
          depressed
          color="error"
          class="ma-3"
          @click="
            modal = false
            selectedReason = ''
          "
          >Cancel</v-btn
        >
        <v-spacer></v-spacer>
        <v-btn
          depressed
          v-if="isSignatureRequired"
          :loading="buttonProgress"
          :disabled="!signature.url || !selectedReason"
          color="primary"
          class="ma-3"
          @click="reject"
          >Reject</v-btn
        >
        <v-btn
          depressed
          v-else
          :loading="buttonProgress"
          :disabled="!this.selectedReason"
          color="primary"
          class="ma-3"
          @click="reject"
          >Reject</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
import OptionSignature from '@/components/options/OptionSignature'

export default {
  components: {
    OptionSignature
  },
  data() {
    return {
      modal: false,
      selectedReason: '', //
      buttonProgress: false,
      signature: {
        modal: false,
        file: null,
        presignedURL: null,
        url: null
      }
    }
  },
  props: {
    isSignatureRequired: {
      type: Boolean,
      required: true
    },
    signatureQuestion: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapGetters({
      selectedForm: 'form/selectedForm',
      selectedSubmission: 'form/selectedSubmission',
      selectedSubmissionSection: 'form/selectedSubmissionSection'
    })
  },
  methods: {
    openRejectModal() {
      this.modal = true
    },

    handleSignature(signature) {
      this.signature.file = signature.file
      this.signature.url = signature.url
      this.signature.presignedURL = signature.presignedURL
    },

    clearSignature() {
      this.signature.file = ''
    },

    reject() {
      let data = {
        confirmType: false,
        signature: this.signature,
        reason: this.selectedReason
      }
      this.$emit('reject-submission', data)
    }
  }
}
</script>

<style></style>
